import {ReactNode} from "react";
import {ResizableHandle, ResizablePanel, ResizablePanelGroup} from "@/components/ui/resizable.tsx";

export default function ManagementWorkspace({sidebar, children}: {
    sidebar: ReactNode;
    children: ReactNode;
}) {
    return (
        <ResizablePanelGroup className="bg-background">
            <ResizablePanel defaultSize={300} minSize={300} collapsible className="flex flex-col">
                {sidebar}
            </ResizablePanel>
            <ResizableHandle withHandle/>
            <ResizablePanel className="flex min-w-0 flex-col p-3">
                {children}
            </ResizablePanel>
        </ResizablePanelGroup>
    );
}
